<template>
    <div>    
        <el-form ref="form" :model="question_info" class="main_form" v-if="question_info.length > 0">
            <template v-for="item in question_info">
                <div :key="item.id" class="main_form_div">
                    <el-form-item :label="item.category" class="main_form_category"></el-form-item>
                    <template v-for="sub_item in item.sub_category">
                        <div :key="sub_item" class="sub_category">
                            <div class="sub_category_desc"><span>>> {{ sub_item.sub_category_desc }}</span></div>
                            <template v-for="sj in sub_item.subject">
                                <div :key="sj.subject_desc_main">
                                    <el-form-item label="" class="subject_info">
                                        <!-- <div style="text-align:left;"><span>{{ sj.subject_desc_sub }}</span></div> -->
                                        <span slot="label" v-if="!sj.selected_option && error_flag" style="color:red;"><span style="font-weight:bold;">{{ sj.subject_desc_main }}</span> ：{{ sj.subject_desc_sub }}</span>
                                        <span slot="label" v-if="(sj.selected_option && error_flag) || !error_flag"><span style="font-weight:bold;">{{ sj.subject_desc_main }}</span> ：{{ sj.subject_desc_sub }}</span>
                                    </el-form-item>
                                    <div class="option_info">
                                        <template v-for="option in sj.options">   
                                            <el-radio :key="option" v-model="sj.selected_option" :label="option" v-if="!sj.selected_option && error_flag" style="color:red;">{{ option }}</el-radio>
                                            <el-radio :key="option" v-model="sj.selected_option" :label="option" v-if="(sj.selected_option && error_flag) || !error_flag">{{ option }}</el-radio>
                                        </template>
                                    </div>
                                </div>
                            </template>
                        </div>
                    </template>
                </div>
            </template>
            <el-form-item label="举证说明" class="main_form_category"></el-form-item>
            <template v-for="item in proof_info">
                <div :key="item.proof_desc" class="proof_area">
                    <el-form-item :label="item.proof_desc"></el-form-item>
                    <el-input
                        type="textarea"
                        resize="none"
                        :placeholder="item.proof_default"
                        :rows="4"
                        v-model="item.proof">
                        <span slot="placeholder">{{ item.proof_default }}</span>
                    </el-input>
                </div>
            </template>
        </el-form>
        <!-- <div v-if="question_info.length <= 0" class="no_ques">暂无问卷信息，请先导入。</div> -->
        <div v-if="display_flag===true" class="no_ques" v-cloak>暂无问卷信息，请先导入。</div>
    </div>   
</template>

<script>
import postdata from "@/api/postData.js";
// import getdata from "@/api/getData.js";
export default {
    // 组件传递的prop数据，会在beforeUpdate钩子期间生效！
    beforeUpdate() {
        if(this.question_info.length <= 0){
            this.display_flag = true;
        }else{
            // 这里要增加else的处理，在导入模板后更新display_flag的值，因为没有重新加载页面，所以此时的display_flag不会从重置为初始值false开始判断
            this.display_flag = false;
        }
    },
    data() {
        return {
            template_file: {
                file_name: 'question-import_template.xlsx'
            },
            formInline: {
                search_info: '',
                search_result: [],
            },
            display_flag: false,
            // 这里直接使用父组件传递的问卷信息，即下面props中的数据
            // question_info: [{
            //     id: 1,
            //     category: '干部能力要求：拿结果',
            //     sub_category: [{
            //         sub_category_desc: '拿结果-明确任务',
            //         subject: [{
            //             subject_desc_main: '确定目标',
            //             subject_desc_sub: '主动理解团队业务目标，站在现在想未来，以数据分析为基础，按SMART原则分解成若干操作性强、可落地的子目标',
            //             options: ['1分', '2分', '3分', '4分', '5分'],
            //             selected_option: '',
            //         },{
            //             subject_desc_main: '界定任务',
            //             subject_desc_sub: '将子任务分解成可落地的任务，界定清楚每个任务的背景信息、产出的交付标准和时间节点，让员工清楚任务的真正意义和价值',
            //             options: ['1分', '2分', '3分', '4分', '5分'],
            //             selected_option: '',
            //         },{
            //             subject_desc_main: '分配任务',
            //             subject_desc_sub: '将团队的任务，通过合理有效的分解，使团队中每位成员都了解自己的工作职责及分工',
            //             options: ['1分', '2分', '3分', '4分', '5分'],
            //             selected_option: '',
            //         }]
            //     },{
            //         sub_category_desc: '拿结果-追踪过程',
            //         subject: [{
            //             subject_desc_main: '发现问题',
            //             subject_desc_sub: '主动理解团队业务目标，站在现在想未来，以数据分析为基础，按SMART原则分解成若干操作性强、可落地的子目标',
            //             options: ['1分', '2分', '3分', '4分', '5分'],
            //             selected_option: '',
            //         },{
            //             subject_desc_main: '持续改进',
            //             subject_desc_sub: '将子任务分解成可落地的任务，界定清楚每个任务的背景信息、产出的交付标准和时间节点，让员工清楚任务的真正意义和价值',
            //             options: ['1分', '2分', '3分', '4分', '5分'],
            //             selected_option: '',
            //         },{
            //             subject_desc_main: '灵活调整',
            //             subject_desc_sub: '将团队的任务，通过合理有效的分解，使团队中每位成员都了解自己的工作职责及分工',
            //             options: ['1分', '2分', '3分', '4分', '5分'],
            //             selected_option: '',
            //         }]
            //     },{
            //         sub_category_desc: '拿结果-达成结果',
            //         subject: [{
            //             subject_desc_main: '取得胜利',
            //             subject_desc_sub: '主动理解团队业务目标，站在现在想未来，以数据分析为基础，按SMART原则分解成若干操作性强、可落地的子目标',
            //             options: ['1分', '2分', '3分', '4分', '5分'],
            //             selected_option: '',
            //         },{
            //             subject_desc_main: '定期复盘',
            //             subject_desc_sub: '将子任务分解成可落地的任务，界定清楚每个任务的背景信息、产出的交付标准和时间节点，让员工清楚任务的真正意义和价值',
            //             options: ['1分', '2分', '3分', '4分', '5分'],
            //             selected_option: '',
            //         },{
            //             subject_desc_main: '经验沉淀',
            //             subject_desc_sub: '将团队的任务，通过合理有效的分解，使团队中每位成员都了解自己的工作职责及分工',
            //             options: ['1分', '2分', '3分', '4分', '5分'],
            //             selected_option: '',
            //         }]
            //     }]
            //     // proof_desc: '举证说明（针对该维度的评价，不少于20字）',
            //     // proof_default: '请根据被评估人在践行企业“值得信赖”文化价值观方面的表现，陈述论据，为了让反馈更有效，请至少输入20个字。',
            //     // proof: '',
            // },
            // {
            //     id: 2,
            //     category: '干部能力要求：找对人',
            //     sub_category: [{
            //         sub_category_desc: '找对人-明确标准',
            //         subject: [{
            //             subject_desc_main: '确定要求',
            //             subject_desc_sub: '主动理解团队业务目标，站在现在想未来，以数据分析为基础，按SMART原则分解成若干操作性强、可落地的子目标',
            //             options: ['1分', '2分', '3分', '4分', '5分'],
            //             selected_option: '',
            //         },{
            //             subject_desc_main: '建人才库',
            //             subject_desc_sub: '将子任务分解成可落地的任务，界定清楚每个任务的背景信息、产出的交付标准和时间节点，让员工清楚任务的真正意义和价值',
            //             options: ['1分', '2分', '3分', '4分', '5分'],
            //             selected_option: '',
            //         },{
            //             subject_desc_main: '精准匹配',
            //             subject_desc_sub: '将团队的任务，通过合理有效的分解，使团队中每位成员都了解自己的工作职责及分工',
            //             options: ['1分', '2分', '3分', '4分', '5分'],
            //             selected_option: '',
            //         }]
            //     },{
            //         sub_category_desc: '找对人-筛选判断',
            //         subject: [{
            //             subject_desc_main: '准备问题',
            //             subject_desc_sub: '主动理解团队业务目标，站在现在想未来，以数据分析为基础，按SMART原则分解成若干操作性强、可落地的子目标',
            //             options: ['1分', '2分', '3分', '4分', '5分'],
            //             selected_option: '',
            //         },{
            //             subject_desc_main: '深度追问',
            //             subject_desc_sub: '将子任务分解成可落地的任务，界定清楚每个任务的背景信息、产出的交付标准和时间节点，让员工清楚任务的真正意义和价值',
            //             options: ['1分', '2分', '3分', '4分', '5分'],
            //             selected_option: '',
            //         },{
            //             subject_desc_main: '交叉验证',
            //             subject_desc_sub: '将团队的任务，通过合理有效的分解，使团队中每位成员都了解自己的工作职责及分工',
            //             options: ['1分', '2分', '3分', '4分', '5分'],
            //             selected_option: '',
            //         },{
            //             subject_desc_main: '精准选拔',
            //             subject_desc_sub: '将团队的任务，通过合理有效的分解，使团队中每位成员都了解自己的工作职责及分工',
            //             options: ['1分', '2分', '3分', '4分', '5分'],
            //             selected_option: '',
            //         }]
            //     },{
            //         sub_category_desc: '找对人-帮助融合',
            //         subject: [{
            //             subject_desc_main: '吸引加盟',
            //             subject_desc_sub: '主动理解团队业务目标，站在现在想未来，以数据分析为基础，按SMART原则分解成若干操作性强、可落地的子目标',
            //             options: ['1分', '2分', '3分', '4分', '5分'],
            //             selected_option: '',
            //         },{
            //             subject_desc_main: '增加归属',
            //             subject_desc_sub: '将子任务分解成可落地的任务，界定清楚每个任务的背景信息、产出的交付标准和时间节点，让员工清楚任务的真正意义和价值',
            //             options: ['1分', '2分', '3分', '4分', '5分'],
            //             selected_option: '',
            //         }]
            //     }]
            //     // proof_desc: '举证说明（针对该维度的评价，不少于20字）',
            //     // proof_default: '请根据被评估人在践行企业“专业胜任”文化价值观方面的表现，陈述论据，为了让反馈更有效，请至少输入20个字。',
            //     // proof: '',
            // }],
            // proof_info: [{
            //     proof_desc: '请举证说明管理方面做得好的地方：',
            //     proof_default: '为了让反馈更有效，请至少输入20个字。',
            //     proof: '',
            // },{
            //     proof_desc: '请举证说明管理方面待提升的地方：',
            //     proof_default: '为了让反馈更有效，请至少输入20个字。',
            //     proof: '',
            // }]
        }
    },
    // props: ['send_id', 'send_type'],
    props: ['question_info', 'proof_info', 'error_flag'],
    methods: {
        // handleSizeChange: function(size) {
        //     // 这里的size还有下面的currentPage都是系统自动识别到的，直接使用即可
        //     this.pageinfo.page_size = size;
        //     // console.log(this.pageinfo.page_size)
        //     // 如果后台获取的数据较大，可考虑根据分页信息从后台获取对应的信息（不全量获取）
        // },
        // handleCurrentChange: function(currentPage) {
        //     this.pageinfo.current = currentPage;
        //     // console.log(this.pageinfo.current)
        //     // 如果后台获取的数据较大，可考虑根据分页信息从后台获取对应的信息（不全量获取）
        // },
        // getManaQues() {
        //     getdata.getList("getManaQues")
        //     .then(resp => {
        //         // console.log(resp);
        //         if(resp.data.code == 200){
        //             this.question_info = resp.data.choice;
        //             this.proof_info = resp.data.proof;
        //             console.log('send_id: ' + this.send_id);
        //             console.log('send_type: ' + this.send_type);
        //             if(this.send_id != null && this.send_type != null){                        
        //                 this.getResultByUser(this.send_id, this.send_type);
        //             }
        //         }
        //         // loading.close();
        //     })
        //     .catch(err => {
        //         console.log(err);
        //     });
        // },
        Download_template() {
            postdata.downloadFiles("download", JSON.stringify(this.template_file))
              .then(resp => {
                // 将流文件通过浏览器下载，这里使用整个后台返回的response，供download函数提取data、headers等信息
                this.download(resp);
              })
              .catch(err => {
                console.log(err);
              })
        },
        download (res) {
            let blob = new Blob([res.data], { type: "application/vnd.ms-excel" });//type是文件类，详情可以参阅blob文件类型
            // 创建新的URL并指向File对象或者Blob对象的地址
            const blobURL = window.URL.createObjectURL(blob)
            // 创建a标签，用于跳转至下载链接
            const tempLink = document.createElement('a')
            tempLink.style.display = 'none'
            tempLink.href = blobURL
            tempLink.setAttribute('download', decodeURI(res.headers['content-disposition'].split(';')[1].split('=')[1]))
            // 兼容：某些浏览器不支持HTML5的download属性
            if (typeof tempLink.download === 'undefined') {
                tempLink.setAttribute('target', '_blank')
            }
            // 挂载a标签
            document.body.appendChild(tempLink)
            tempLink.click()
            document.body.removeChild(tempLink)
            // 释放blob URL地址
            window.URL.revokeObjectURL(blobURL)
        },
        // 向父组件传递问卷测评结果（包括选择题和举证题两部分）
        submitManaQues() {
            // console.log('send data to father component.');
            this.$emit('sendData', [this.question_info, this.proof_info]);
        },
        // getResultByUser(assessee_id, eval_type) {
        //     let params;
        //     params = {
        //         assessee_id: assessee_id,
        //         eval_type: eval_type,
        //     } 
            
        //     getdata.getListP("getManaResults", params)
        //     .then(resp => {
        //         if(resp.data.code == 200){
        //             var result = resp.data.data;
        //             console.log('result: ' + result + ' ' + result[0]);
        //             var i = 0; 
        //             for(var cg in this.question_info){
        //                 for(var scg in this.question_info[cg]['sub_category']){
        //                     for(var sj in this.question_info[cg]['sub_category'][scg]['subject']){
        //                         this.question_info[cg]['sub_category'][scg]['subject'][sj]['selected_option'] = result[i];
        //                         i = i + 1;
        //                     }
        //                 }
        //             }
        //         }
        //     })
        //     .catch(err => {
        //         console.log(err);
        //     });
        // },
    }
}
</script>

<style scoped>
[v-cloak]{
    display: none !important;
}
.dialog_form /deep/ .el-input {
    width: 223.67px;
}
::v-deep .el-form-item {
    margin-bottom: 0;
}
.main_form {
    padding: 20px;
    /* min-width: 1900px; */
}
.main_form_div {
    /* background: #f5f7fa; */
    margin-bottom: 25px;
}
.main_form_div /deep/ .el-form-item__label {
    font-size: 16px;
    line-height: 30px;
    color: #409EFF;
}
.main_form_category {
    border-left: solid 8px #409EFF;
    padding-left: 15px;
    font-weight: bold;
    margin-bottom: 10px;
}
.main_form_category /deep/ .el-form-item__label {
    font-size: 16px;
    line-height: 30px;
    color: #409EFF;
}
.sub_category {
    border: 1.3px solid #E4E7ED;
    margin-bottom: 10px;
}
.sub_category_desc {
    text-align: left;
    margin-bottom: 10px;
    padding: 8px;
    font-size: 16px;
    font-weight: bold;
    color: #606266;
}
.subject_info {
    /* background: #cee4f1; */
    background: #f5f7fa;
    /* opacity: 0.4; */
    padding-left: 10px;
    margin-bottom: 2px;
}
.subject_info /deep/ .el-form-item__label {
    /* width: 75%; */
    text-align: left;
    color: #606266;
    font-size: 14px;
    line-height: 40px;
}
/* .subject_info /deep/ .el-form-item__content {
    width: 650px;
    float: right;
} */
.option_info {
    text-align: left;
    height: 35px;
    line-height: 35px;
    margin-left: 80px;
}
.proof_area /deep/ .el-form-item__label {
    font-size: 15px;
    color: #606266;
}
.no_ques {
  width: 100%;
  margin: 0 auto;
  color: #909399;
  font-weight: bold;
  height: 60px;
  line-height: 60px;
  margin-top: 20px;
}
</style>